<template>
  <element>
    <nav-breadcrumb :menu="[{label: '意向客户'}, {label: '审核&授信'}]"/>
    <el-row>


      <el-col class="grid-content bg-purple">
        <el-tabs v-model="tabName">
          <template>
            <el-tab-pane label="客户信息" name="CustomerSummary">
             <!-- <template>
                <customer-detail-component v-model="customerDetail"/>
              </template>-->
              <panel label="基本信息">
                <form-build
                  :form-data.sync="customerDetail"
                  :form-rules="customerRules"
                  :form-columns="customerColumns"
                  class="formTable"
                />
              </panel>
              <panel label="证件图片" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.i__bizrepICURL1" prefix="images/"></image-upload>
                  <label>本人身份证正面</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.i__bizrepICURL2" prefix="images/"></image-upload>
                  <label>本人身份证反面</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extSpouseIDFront" prefix="images/"></image-upload>
                  <label>配偶身份证正面</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extSpouseIDBack" prefix="images/"></image-upload>
                  <label>配偶身份证反面</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extMarriageCert" prefix="images/"></image-upload>
                  <label>结婚证明</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extHouseholdRegBook1" prefix="images/"></image-upload>
                  <label>本人户口本主页</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extHouseholdRegBook2" prefix="images/"></image-upload>
                  <label>本人户口本</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extHouseholdRegBook3" prefix="images/"></image-upload>
                  <label>配偶户口本</label>
                </div>

                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extResidencePermit" prefix="images/"></image-upload>
                  <label>借款人居住证</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extSpouseResidencePermit" prefix="images/"></image-upload>
                  <label>借款人配偶居住证</label>
                </div>
              </panel>
              <panel label="资产证明" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extPropertyCert" prefix="images/"></image-upload>
                  <label>房产证</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extPropertyPhoto" prefix="images/"></image-upload>
                  <label>房屋照片</label>
                </div>
              </panel>
              <panel label="征信证明" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <file-upload  v-model="customerDetail.ix__extBizAnalysis"></file-upload>
                  <label>借款人运营情况分析报告</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <file-upload  v-model="customerDetail.ix__extBankStatement"></file-upload>
                  <label>借款人银行流水</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <file-upload  v-model="customerDetail.ix__extGovStatement"></file-upload>
                  <label>最近3个月社保或公积金缴纳明细</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extCreditReportAuth" prefix="images/"></image-upload>
                  <label>代拉征信授权书</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <file-upload  v-model="customerDetail.ix__extCreditReport"></file-upload>
                  <label>征信报告</label>
                </div>
              </panel>
              <panel label="贷款相关图片" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extBankCard" prefix="images/"></image-upload>
                  <label>借款人银行卡</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extAppearancePhoto" prefix="images/"></image-upload>
                  <label>夫妻双方现场照</label>
                </div>
              </panel>


            </el-tab-pane>
            <el-tab-pane label="抵押车辆" name="vehiclesDetail" >


              <panel label="车辆信息" v-for="(item,idx) in customerDetail.vehicles" :key="idx">
                <form-build
                  :form-data="item"
                  :form-columns="vehicleFormColumns"
                  class="formTable"
                />
                <panel label="证件图片">
                  <div class="zhenjianyyzz zhenjianyyzz2">
                    <image-upload  v-model="item.vehicle__vehicleRegCert" prefix="images/"> </image-upload>
                    <label>车辆登记证</label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2">
                    <image-upload  v-model="item.vehicle__vehicleLicenseURL" prefix="images/"></image-upload>
                    <label>行驶证</label>
                  </div>

                  <div class="zhenjianyyzz zhenjianyyzz2">
                    <image-upload  v-model="item.vehicle__vehicleDriverLicense" prefix="images/"></image-upload>
                    <label>车辆驾驶员驾驶证</label>
                  </div>

                </panel>
                <panel label="车辆相关图片">
                  <div class="zhenjianyyzz zhenjianyyzz2">
                    <image-upload  v-model="item.vehicle__vehicleInsurance1" prefix="images/"> </image-upload>
                    <label>车辆交强险</label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2">
                    <image-upload  v-model="item.vehicle__vehicleInsurance2" prefix="images/"></image-upload>
                    <label>车辆商业险</label>
                  </div>

                  <div class="zhenjianyyzz zhenjianyyzz2">
                    <image-upload  v-model="item.vehicle__vehicleInvoice" prefix="images/"></image-upload>
                    <label>车辆发票</label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2">
                    <image-upload  v-model="item.vehicle__vehicleOwnershipCert" prefix="images/"></image-upload>
                    <label>车辆权属证明</label>
                  </div>

                </panel>
              </panel>

            </el-tab-pane>
            <el-tab-pane label="担保信息" name="guarantor" class="bg-purple">
              <!--<customer-detail-guarantor-component v-model="customerDetail"/>-->
              <form-build
                :form-data="customerDetail"
                :form-columns="extColumns"
                class="formTable"
              />
              <panel label="证件图片">
                <div class="zhenjianyyzz zhenjianyyzz2">
                <image-upload  v-model="customerDetail.ix__extCompanyLicense" prefix="images/"></image-upload>
                <label>营业执照</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                <image-upload  v-model="customerDetail.ix__extCompanyBizRepIC" prefix="images/"></image-upload>
                <label>法人代表身份证</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                <image-upload  v-model="customerDetail.ix__extCompanyRoadLicense" prefix="images/"></image-upload>
                <label>道路运输许可证</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                <image-upload  v-model="customerDetail.ix__extGuarantorCompanyBankPermit" prefix="images/"></image-upload>
                <label>开户许可证</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                <image-upload  v-model="customerDetail.ix__extGuarantorMarriageCert" prefix="images/"></image-upload>
                <label>担保人结婚证明</label>
                </div>
              </panel>
              <panel label="资产证明" class="zhengjianxinxi">

                <div class="zhenjianyyzz zhenjianyyzz2">
                <image-upload  v-model="customerDetail.ix__extGuarantorRentalAgreement" prefix="images/"></image-upload>
                <label>租屋协议</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <file-upload  v-model="customerDetail.ix__extGuarantorShareholdResolution"></file-upload>
                  <label>股东决议</label>
                </div>
              </panel>
              <panel label="相关证明" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2">
                <image-upload  v-model="customerDetail.ix__extGuarantorCompanyPhoto1" prefix="images/"></image-upload>
                <label>公司室内环境</label>
                </div>
              </panel>

            </el-tab-pane>
            <el-tab-pane label="挂靠公司" name="ext-company" class="bg-purple">
              <!--<customer-detail-ext-company-component v-model="customerDetail" />-->
              <panel>
                <form-build
                  :form-data="customerDetail"
                  :form-columns="extCompanyColumns"
                  class="formTable"
                />
              </panel>
              <panel label="证件图片" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extCompanyLicense" prefix="images/"></image-upload>
                  <label>营业执照</label>

                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extCompanyBizRepIC" prefix="images/"></image-upload>
                  <label>法人代表身份证</label>

                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.ix__extCompanyRoadLicense" prefix="images/"></image-upload>
                  <label>道路运输许可证</label>

                </div>
              </panel>
            </el-tab-pane>
            <el-tab-pane label="贷前风控" name="tongdun" class="bg-purple">
              <customer-tongdun-component v-model="customerDetail" :is-show-pic1="true"/>
            </el-tab-pane>
          </template>
        <!--  <el-tab-pane label="授信详情" name="creditDetail" v-if="creditForm.a__approvingStatus == 'Approved'">
            <template v-if="creditForm.a__approvingStatus == 'Approved'">
              <form-build
                form-name="creditForm"
                :form-data.sync="creditForm"
                :form-columns-group="creditFormColumnsGroup"
                :form-rules="creditFormRules"
                :form-buttons="creditFormButtons"
                label-width="170px"
                ref="FormBuild"
              />
              <el-row>
                <el-col :span="24">
                  <files-upload :file-list.sync="fileList"></files-upload>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-button type="danger" @click="onSubmit('creditForm')">确认提交</el-button>
                  <el-button @click="$router.back()">取消</el-button>
                </el-col>
              </el-row>
            </template>
          </el-tab-pane>-->
        </el-tabs>
           <form-build
             :form-data.sync="customerDetail"
             :form-rules="customerRules"
             :form-columns-group="remarksColumns"
             form-name="formTable"
           />
        <el-col :span="24">
          <el-button type="primary" @click="onSubmit()">确认提交</el-button>
          <el-button @click="$router.back()">取消</el-button>
        </el-col>
      </el-col>
    </el-row>
  </element>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import creditTypeOptions from '../../../utils/creditTypeOptions'
  import CustomerDetailComponent from '../../components/CustomerDetailComponent'
  import CustomerDetailVehiclesComponent from "../../components/CustomerDetailVehiclesComponent";
  import CustomerDetailGuarantorComponent from "../../components/CustomerDetailGuarantorComponent";
  import CustomerDetailExtCompanyComponent from "../../components/CustomerDetailExtCompanyComponent";
  import FilesDataTable from '../../../components/FilesDataTable'
  import ImageUpload from "../../../components/ImageUpload";
  import Panel from "../../../components/Panel";
  import CustomerTongdunComponent from "../../components/CustomerTongdunComponent";

  export default {
    name: "CustomerApplyingApproveKF",
    data() {
      return {
        remarksColumns:[
          {
            label: '审查结果',
            columns: [
              {
                label: '审查意见',
                field: 'i__remarks',
                component: 'el-input',
                type: 'textarea',
                span: 24
              }
            ]
          }

        ],
        tabName: 'CustomerSummary',
        creditId: this.$route.query['cr.creditId']||'',
        customerDetail: {
          vehicles: [],
          "isNext":"N"
        },
        debtorList:{},
        productList: {},
        creditTypeOptions: creditTypeOptions,
        approvalForm: {
          "a__approvingStatus": "Rejected",
          "a__remarks": ""
        },
        approvalFormRules: {

        },
        approvalFormColumnsGroups: [
          {
            label: '审核结果',
            columns: [
              {
                label: '审核意见',
                component: 'el-input',
                type: 'textarea',
                field: 'a__remarks',
                span: 24
              }
            ]
          }
        ],
        approvalFormButtons: [
          {
            label: '审核通过',
            type: 'primary',
            clickHandler: ($refs)=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.creditForm.a__approvingStatus = 'Approved'
                  this.creditForm.a__remarks = this.approvalForm.a__remarks
                  this.tabName = 'creditDetail'
                }
              })
            }
          },
          {
            label: '否决',
            clickHandler: ($refs)=>{
              this.creditForm.a__approvingStatus = 'Rejected'
              this.creditForm.a__remarks = this.approvalForm.a__remarks

              this.updateApproveCustomer()
            }
          }
        ],
        creditForm: {
          "c__applicationId" : this.$route.query['c.applicationId'],
          "c__applicationStatus":"Pending Approval",
          "a__approvingStatus": 'Rejected',
          "a__remarks": "",
          "cr__checked": true,
          "cr__creditId": this.$route.query['cr.creditId']||'',
          "cr__creditType": "",
          "cr__creditValidity": [],
          "cr__creditValidity1": "",
          "cr__creditValidity2": "",
          "cr__customerId": "",
          "cr__debtorId": "",
          "cr__financingRatio": "",
          "cr__lineOfCredit": 0,
          "cr__productId": "",
          "cr__threshold": "",
          files: []
        },
        customerColumns: [
          {
            label: '客户编号',
            field: 'c__customerCode',
            formatter: function (r,v) {
              return  v ? v : '待生成'
            }
          },
          {
            label: '身份证号码',
            field: 'i__socialIdentityCode',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '客户姓名',
            field: 'i__contactPerson',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '性别',
            field: 'ix__extGender',
            component: 'el-select',
            options:[
              {
                label:'男',
                value:'M'
              },
              {
                label:'女',
                value:'F'
              }
            ],

          },


          {
            label: '手机号',
            field: 'i__contactTelNo',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '业务员',
            field: 'ix__extSalesPerson',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '常住地址',
            field: 'i__address',
            component: 'el-input',
            formatter: function(r,v) {
              return (r.i__province||'') + (r.i__city||'') + v
            },
            span:24
          },

          {
            label: '婚姻状况',
            field: 'ix__extMaritalStatus',
            component: 'el-input',
            type: 'text',
          },

          {
            label: '配偶姓名',
            field: 'ix__extSpouseName',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '配偶手机',
            field: 'ix__extSpouseContactTelNo',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '配偶身份证号',
            field: 'ix__extSpouseIC',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '配偶工作单位',
            field: 'ix__extSpouseEmployedBy',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '配偶工作地址',
            field: 'ix__extSpouseEmployAddress',
            component: 'el-input',
            type: 'text',
            span:24
          },

          {
            label: '获客渠道',
            field: 'ix__channel'
          },
          /*{
            label: '评分',
            field: 'ix__extScore',
            component: 'el-input',
            type: 'text',
          },*/
          {
            label: '个人征信状况',
            field: 'ix__extCreditDesc',
            component: 'el-input',
            type: 'text',
          },
          {
            label:'建议授信额度',
            field:'ix__extLineOfCredit',
            component: 'el-input',
            type: 'text',
            unit: '元'
          },
          {
            label: '服务年限',
            field: 'ix__extServicingPeriod',
            component: 'el-input',
            type: 'text',
          },

        ],
        customerRules:{},
        /*customerRules:{
          i__socialIdentityCode: [
            {
              required: true,
              message: '身份证号码不能为空！'
            }
          ],
          i__contactPerson: [
            {
              required: true,
              message: '客户姓名不能为空！'
            }
          ],
          i__contactTelNo: [
            {
              required: true,
              message: '手机号不能为空！'
            }
          ],
          i__contactPerson: [
            {
              required: true,
              message: '客户姓名不能为空！'
            }
          ],
        },*/
        extCompanyColumns:[
          {
            label: '挂靠公司',
            field: 'ix__extCompany',
            component: 'el-input',
          },
          {
            label: '挂靠单位法人',
            field: 'ix__extCompanyBizRep',
            component: 'el-input',
          },
          {
            label: '挂靠单位地址',
            field: 'ix__extCompanyAddress',
            component: 'el-input',
            span:24
          },
        ],
        extColumns:[
          {
            label: '公司名称',
            field: 'ix__extGuarantorCompanyName',
            component: 'el-input',
          },
          {
            label: '联系方式',
            field: 'ix__extGuarantorCompanyContactNo',
            component: 'el-input',
          },

          {
            label: '注册时间',
            field: 'ix__extGuarantorCompanyRegDate',
            component: 'el-date-picker',
            valueFormat: 'yyyy-MM-dd'
          },
          /* {
             label: '期限/年月',
             field: 'vehicle__lifespan',
           },*/
          {
            label: '法人代表',
            field: 'ix__extGuarantorCompanyBizRep',
            component: 'el-input',
          },
          {
            label: '公司地址',
            field: 'ix__extGuarantorCompanyAddress',
            component: 'el-input',
            span:24
          },
        ],
        vehicleFormColumns: [
          {
            label: '车牌号',
            field: 'vehicle__plateNo',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '车辆类型',
            field: 'vehicle__specification',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '车架号',
            field: 'vehicle__vehicleNo',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '发动机号',
            field: 'vehicle__engineNo',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '车辆上牌时间',
            field: 'vehicle__registrationDate',
            component: 'el-date-picker',
            valueFormat: 'yyyy-MM-dd'
          },
          {
            label: '车辆发票价格',
            field: 'vehicle__buyPrice',
            component: 'el-input',
            type: 'text',
            unit: '元'
          },
          {
            label: 'GPS号码',
            field: 'vehicle__GPS',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '测算额度',
            field: 'vehicle__currentValue',
            component: 'el-input',
            type: 'text',
            unit: '元'
          },
          {
            label: '物流领域',
            field: 'vehicle__bizArea',
            component: 'el-input',
            type: 'text',
          },

         /* {
            label: '期限/年月',
            field: 'vehicle__lifespan',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '车辆单价',
            field: 'vehicle__buyPrice',
            component: 'el-input',
            type: 'text',
            unit: '元'
          },
          {
            label: '折合后车辆单价',
            field: 'vehicle__currentValue',
            component: 'el-input',
            type: 'text',
            unit: '元'
          },
          {
            label: 'GPS号码',
            field: 'vehicle__GPS',
            component: 'el-input',
            type: 'text',
          },*/
          /*{
            label: ' 购买价格',
            field: 'vehicle__buyPrice',
            formatter: function (r,v) {
              return formatMoney(v)+'元'
            }
          },*/
        /*  {
            label: '常用运营路线',
            field: 'vehicle__operatingLines',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '违章次数',
            field: 'vehicle__trafficOffence',
            component: 'el-input',
            type: 'text',
          },*/
          {
            label: '里程（12个月）',
            field: 'vehicle__mileage12',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '加油费（12个月）',
            field: 'vehicle__fuelExpense12',
            component: 'el-input',
            type: 'text',
            unit: '元'
          },
          {
            label: '通行费（12个月）',
            field: 'vehicle__roadToll12',
            component: 'el-input',
            type: 'text',
            unit: '元'
          },

        ]

      }
    },
    components: {
      Panel,
      ImageUpload,

      CustomerDetailExtCompanyComponent,
      CustomerDetailGuarantorComponent,
      CustomerDetailComponent,
      CustomerDetailVehiclesComponent,
      FilesDataTable,
      CustomerTongdunComponent
    },
    computed: {
      c__applicationId() {
        return this.$route.query['c.applicationId']
      },
      creditFormColumnsGroup() {
        return [
          {
            label: '授信详情',
            columns: [
              // {
              //   label: '客户名称',
              //   field: 'cr__customerId',
              //   component: 'el-select',
              //   filterable: true,
              //   options: this.customerList
              // },
              {
                label: '供应链',
                field: 'cr__debtorId',
                filterable: true,
                component: 'el-select',
                options: this.debtorList
              },
              {
                label: '贷款产品',
                field: 'cr__productId',
                filterable: true,
                component: 'el-select',
                options: this.productList
              },
              {
                label: '授信类型',
                field: 'cr__creditType',
                filterable: true,
                component: 'el-select',
                options: creditTypeOptions
              },
              {
                label: '核准授信额度',
                field: 'cr__lineOfCredit',
                component: 'el-input',
                unit: '元'
              },
              {
                label: '授信起始-到期日',
                field: 'cr__creditValidity',
                component: 'date-range-picker',
              },
              {
                label: '贷款比例',
                field: 'cr__financingRatio',
                component: 'el-input',
                unit: '%'
              },
              {
                label: '贷款阈值',
                field: 'cr__threshold',
                component: 'el-input',
                unit: '元'
              },
            ]
          },
        ]
      },
      fileList: {
        get() {
          return this.creditForm.files
        },
        set(newVal) {
          this.creditForm.files = newVal.map(item => Object.assign(item, {
              'ca__fileId': item.fileId,
              'ca__checked': true
            })
          )
        }
      }
    },
    mounted() {
      if( this.creditId ) {
        this.getCustomerCreditDetail(this.creditId)
      }
      this.getApplyingCustomerDetail()
      this.getDebtorList()
      this.getFinanceProductList()
    },
    methods: {
      getApplyingCustomerDetail: function () {
        xhr.getApplyingCustomerDetail({
          'c.applicationId': this.$route.query['c.applicationId']
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.customerDetail = res.data.data
              this.customerDetail.vehicles = this.customerDetail.vehicles.filter(item=>item.vehicle__vehicleId)
              if(this.customerDetail.c__applicationStatus=="Pending Approval"){
                this.getApplyCustomerCreditDetail(this.creditId);
              }
            }
          }catch(e){}
        })
      },
      getCustomerCreditDetail: function (creditId) {
        xhr.getCustomerCreditDetail({
            'cr.creditId': creditId
          },
          res=> {
            try{
              if(res.data.status == 'success') {
                res.data.data.cr__creditValidity = [
                  res.data.data.cr__creditValidity1,
                  res.data.data.cr__creditValidity2
                ]
                this.creditForm = res.data.data
              }
            }catch (e) {

            }
          })
      },
      getApplyCustomerCreditDetail: function (creditId) {
        xhr.getApplyCustomerCreditDetail({
            'cr.creditId': creditId
          },
          res=> {
            try{
              if(res.data.status == 'success') {
                res.data.data.cr__creditValidity = [
                  res.data.data.cr__creditValidity1,
                  res.data.data.cr__creditValidity2
                ]
                this.creditForm = res.data.data
              }
            }catch (e) {

            }
          })
      },
      getDebtorList: function () {
        xhr.getDebtorList({
          pageSize: 1000
        },res=>{
          try{
            if(res.data.status == 'success') {
              this.debtorList = res.data.data.map(item=>{
                return {
                  label: item.c__customerName,
                  value: item.c__customerId
                }
              })
              if(this.debtorList.length == 1) {
                this.creditForm.cr__debtorId = this.debtorList[0].value
              }
            }
          }catch (e) {

          }
        })
      },
      getFinanceProductList: function () {
        xhr.getFinanceProductList(
          {
            pageSize: 1000
          },
          res=>{
            try{
              if(res.data.status == 'success') {
                this.productList = res.data.data.map(item=>{
                  return {
                    label: item.p__productName,
                    value: item.p__productId
                  }
                })
                if(this.productList.length == 1) {
                  this.creditForm.cr__productId = this.productList[0].value
                }
              }
            }catch (e) {

            }
          }
        )
      },
      onSubmit: function () {
           /* this.updateApproveCustomer()*/
        this.$confirm('是否提交数据进入风控审核', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '暂存',
          type: 'warning'
        }).then(() => {
          this.customerDetail.isNext='Y'
          this.updateApproveCustomerEdit()
        }).catch(() => {
          this.updateApproveCustomerEdit()
        });

      },
      updateApproveCustomerEdit: function () {
        this.creditForm.a__approvalType = 'KF'
        xhr.updateApproveCustomerEdit(
          this.customerDetail,
          res=> {
            try{
              if(res.data.status == 'success') {

              }else{

                this.$message.error(res.data.msgs[0].text)
              }
              this.$router.push({
                path: 'List'
              })
            }catch (e) {

              this.$message.error(error.msgs[0].text)

            }
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerApplyingApproveKF.vue